import { render, staticRenderFns } from "./eod-alarm-detail-deadman.vue?vue&type=template&id=b014ecfc"
import script from "./eod-alarm-detail-deadman.vue?vue&type=script&lang=js"
export * from "./eod-alarm-detail-deadman.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports